import React from 'react';
import { NavLink } from 'react-router-dom';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

const vimages = [
    require('./../../images/gallery/portrait/vert/team1.jpg'),
    require('./../../images/gallery/portrait/vert/team2.jpg'),
    require('./../../images/gallery/portrait/vert/team3.jpg'),
    require('./../../images/gallery/portrait/vert/team4.jpg'),
    require('./../../images/gallery/portrait/vert/team5.jpg'),
    require('./../../images/gallery/portrait/vert/team6.jpg'),
    require('./../../images/gallery/portrait/vert/team7.jpg'),
    require('./../../images/gallery/portrait/vert/team8.jpg'),
    require('./../../images/gallery/portrait/vert/team9.jpg'),
    require('./../../images/gallery/portrait/vert/team10.jpg'),
 
]

const himages = [
    require('./../../images/gallery/portrait/hor/team1.jpg'),
    require('./../../images/gallery/portrait/hor/team2.jpg'),
    require('./../../images/gallery/portrait/hor/team3.jpg'),
    require('./../../images/gallery/portrait/hor/team4.jpg'),
    require('./../../images/gallery/portrait/hor/team5.jpg'),
    require('./../../images/gallery/portrait/hor/team6.jpg'),
    require('./../../images/gallery/portrait/hor/team7.jpg'),
    require('./../../images/gallery/portrait/hor/team8.jpg'),
    require('./../../images/gallery/portrait/hor/team9.jpg'),
    require('./../../images/gallery/portrait/hor/team10.jpg'),
    require('./../../images/gallery/portrait/hor/team11.jpg'),
    require('./../../images/gallery/portrait/hor/team12.jpg'),
    require('./../../images/gallery/portrait/hor/team13.jpg'),
    require('./../../images/gallery/portrait/hor/team14.jpg'),
    
]

var bnr1 = require('./../../images/background/line.png');

class About3 extends React.Component {
    componentDidMount(){
        function loadScript(src) {
           
          return new Promise(function(resolve, reject){
            var script = document.createElement('script');
            script.src = src;
            script.addEventListener('load', function () {
              resolve();
            });
            script.addEventListener('error', function (e) {
              reject(e);
            });
            document.body.appendChild(script);
            document.body.removeChild(script);
          })
        };
 
      loadScript('./assets/js/masonary.js');
      
    };
    render() {
        const options = {
            loop:true,
            autoplay:true,
            autoplayTimeout:3000,
            margin:30,
            nav:false,
            navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
            items:1,
            dots: true
        };
        return (
            <>
                <div className="section-full p-t30 p-b80 bg-white inner-page-padding" style={{ borderBottom: "1px solid #337ab7"}}>
                    <div className="container">
                        <div className="section-content ">
                            <div className="row">

                                <div className="col-lg-12 col-md-12">
                                    <div className="m-about-containt text-black p-t80">
                                        <div className="m-about-years bg-moving" style={{backgroundImage:"url(" + bnr1 + ")"}}>
                                            <span className="text-primary large-title">10</span>
                                            <span className="large-title-info">lat doświadczenia</span>
                                        </div>
                                        <h3 className="font-weight-600"> Sporty ekstremalne to nasza pasja</h3>
                                        <p>Skate Arena Workshop skupia wieloletnie doświadczenie naszych rzemieślników, innowacyjne podejście
projektantów i wspólną determinację do działania na rzecz rozwoju sportów ekstremalnych w Polsce.
</p><p>Podstawą naszego funkcjonowania jest budowa najwyższej jakości skateparków, których sami jesteśmy
stałymi użytkownikami.</p><p>
Wspieramy procesy urbanistyczno- projektowe naszą specjalistyczną wiedzą i angażujemy się w
różnorodne projekty utrwalające pozycję sportów miejskich w otaczającej nas przestrzeni fizycznej i
kulturowej.

</p>
                                        {/* <div className="author-info p-t20">
                                            <div className="author-signature">
                                                <img src={require('./../../images/Signature+Black.png')} alt="Signature" width={150} />
                                            </div>
                                            <div className="author-name">
                                                <h4 className="m-t0">Przemysław  Kępiński</h4>
                                                <p> "Kępol" CEO &amp; Founder</p>
                                            </div>
                                        
                                         
                                            <NavLink to="/about" className="site-button btn-effect m-b15"><span>Napisz do mnie</span></NavLink>
                                        </div>
                                        <div className="author-info p-t20">
                                            <div className="author-signature">
                                                <img src={require('./../../images/Signature+Black.png')} alt="Signature" width={150} />
                                            </div>
                                            <div className="author-name">
                                                <h4 className="m-t0">Paulina Cwynar</h4>
                                                <p>  Partner &amp; Founder</p>
                                            </div>
                                        
                                         
                                            <NavLink to="/about" className="site-button btn-effect m-b15"><span>Napisz do mnie</span></NavLink>
                                        </div>
                                        <div className="author-info p-t20">
                                            <div className="author-signature">
                                                <img src={require('./../../images/Signature+Black.png')} alt="Signature" width={150} />
                                            </div>
                                            <div className="author-name">
                                                <h4 className="m-t0">Bartek</h4>
                                                <p>  Partner </p>
                                            </div>
                                        
                                         
                                            <NavLink to="/about" className="site-button btn-effect m-b15"><span>Napisz do mnie</span></NavLink>
                                        </div> */}
                                    </div>
                                </div>
                                <div className="col-lg-10 col-md-10">
                                    <div className="m-about ">
                                        <OwlCarousel className="owl-carousel about-us-carousel" {...options}>
                                            {himages.map((item, index) => (
                                                <div className="item" key={index}>
                                                    <div className="ow-img">
                                                    <NavLink to="/about"><img src={item} alt=""/></NavLink>
                                                    </div>
                                                </div>
                                            ))}
                                        
                                        </OwlCarousel>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="hilite-title text-left p-l150 text-uppercase ">
                        <strong>O nas</strong>
                    </div>
                </div>
            </>
        );
    }
};

export default About3;